import React from "react"

import "./src/assets/css/font-awesome.min.css"
import "./src/styles/site.css"
import { I18nProvider } from "./src/i18n"

export const wrapRootElement = ({ element }) => (
  <I18nProvider>{element}</I18nProvider>
)

export const onServiceWorkerUpdateFound = () => {
  if (typeof window !== "undefined") {
    window.location.reload()
  }
}
